import type { ServerFeatureFlagName } from '../../routes/account/store/ServerFeatureFlags';
import { useAccount, useStore } from '../index';
import type RootStore from '../RootStore';

export default function useFlag(flag: FeatureFlag): boolean {
  const account = useAccount();
  const store = useStore();

  const flagName = flag as ServerFeatureFlagName;

  if (account?.serverFeatureFlags.getFlag(flagName)) {
    return true;
  }

  if (typeof ClientFlags[flag] === 'function') {
    return ClientFlags[flag](store);
  }

  return false;
}

const ClientFlags = {
  useBunnyCdn(store: RootStore) {
    return store.authStore.userHasRole('ADMIN', { mode: 'any' });
  },
  usePulseCdn(store: RootStore) {
    return store.authStore.userHasRole('ADMIN', { mode: 'any' });
  },
} as const;

export type FeatureFlag = keyof typeof ClientFlags | ServerFeatureFlagName;
